import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, Package, ShoppingCart, MessageSquare, LogOut, ArrowLeft } from "lucide-react";

const NAV = [
  { to: "/admin", end: true, label: "Dashboard", Icon: LayoutDashboard },
  { to: "/admin/products", label: "Products", Icon: Package },
  { to: "/admin/orders", label: "Orders", Icon: ShoppingCart },
  { to: "/admin/enquiries", label: "Enquiries", Icon: MessageSquare },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-[var(--fm-bg)]">
      <aside className="w-60 bg-[var(--fm-primary)] text-white p-6 flex flex-col">
        <Link to="/" className="font-display text-2xl tracking-tight">White Molar</Link>
        <div className="overline text-white/60 mt-1">Admin Console</div>

        <nav className="mt-10 space-y-1 flex-1">
          {NAV.map(({ to, end, label, Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`admin-nav-${label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-white/10 text-white" : "text-white/70 hover:text-white hover:bg-white/5"}`}
            >
              <Icon size={16} strokeWidth={1.5} /> {label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-auto space-y-2">
          <div className="text-xs text-white/60">Signed in as</div>
          <div className="text-sm">{user?.email}</div>
          <Link to="/" className="text-xs text-white/70 hover:text-white inline-flex items-center gap-1 mt-3"><ArrowLeft size={12} /> Back to site</Link>
          <button data-testid="admin-logout" onClick={async () => { await logout(); navigate("/"); }} className="text-xs text-white/70 hover:text-white inline-flex items-center gap-1 mt-2"><LogOut size={12} /> Sign out</button>
        </div>
      </aside>
      <main className="flex-1 p-10 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
